__turbopack_context__.v({
  "city": "hello-module__kG47dW__city",
  "curtain-in": "hello-module__kG47dW__curtain-in",
  "curtain-out": "hello-module__kG47dW__curtain-out",
  "foot": "hello-module__kG47dW__foot",
  "grain": "hello-module__kG47dW__grain",
  "greet": "hello-module__kG47dW__greet",
  "hello": "hello-module__kG47dW__hello",
  "inner": "hello-module__kG47dW__inner",
  "mark": "hello-module__kG47dW__mark",
  "name": "hello-module__kG47dW__name",
  "nudge": "hello-module__kG47dW__nudge",
  "out": "hello-module__kG47dW__out",
  "up": "hello-module__kG47dW__up",
});
